import Api from "~/service/Api";

class UiMeet3dGreetingBotDefaultValueRepository {
  fetch(query) {
    return Api.get("/ui-meet-3d/greeting-bot/default-values", query);
  }
}

export default UiMeet3dGreetingBotDefaultValueRepository;
